export default __webpack_public_path__ + "static/media/Advanced.3ca85fab.png";